'use strict';

let EventEmitter = require('wolfy87-eventemitter');

class PopupWidget extends EventEmitter {

    constructor(rmWidget) {
        super();
        this.rmWidget = rmWidget;
        // always true if the widget is a popup widget
        this.loaded = this.rmWidget.type === 'popup';
        this.rmWidget.on('popupMessage', data => {
            this.emit(data[0], data[1]);
        });

        this.rmWidget.on('popupLoaded', () => {
            this.loaded = true;
            this.emit('loaded');
        });
        this.rmWidget.on('popupClose', () => {
            this.loaded = false;
            this.emit('close');
        });
    }

    send(command, data) {
        this.rmWidget._sendMessage('popupMessage', [command, data]);
    }

    close() {
        this.rmWidget._sendMessage('closePopupWidget');
    }

}

module.exports = PopupWidget;